import { fetchAPI } from "../../../../../config/axios";
import { KRIPenilaianAction, KRIPenilaianActionType, KRIPenilaianDataModel } from "./types";

export const KRIPenilaianMain: KRIPenilaianDataModel = {
  main: {
    data: [],
    total: 0,
  },
};

export const KRIPenilaianReducer = (
  state: KRIPenilaianDataModel = KRIPenilaianMain,
  action: KRIPenilaianAction
): KRIPenilaianDataModel => {
  switch (action.type) {
    case KRIPenilaianActionType.GetKRIPenilaian:
      return { ...state, main: action.data };
    default:
      return state;
  }
};

export const KRIPenilaianCommand = {
  GetKRIPenilaian: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-kri-kriteria-prioritasis",
          { params }
        );
        dispatch({
          type: KRIPenilaianActionType.GetKRIPenilaian,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateKRIPenilaian: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-kri-kriteria-prioritasi",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateKRIPenilaian: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-kri-kriteria-prioritasi",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateSkalaKRIPenilaian: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-kri-kriteria-prioritasi/skala",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteKRIPenilaian: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().delete(
          "/tj-kri-kriteria-prioritasi",
          { params }
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
